import { getCurrentInstance } from 'vue';
import constants from '@/utilities/constants';

export default function useAddCardsToInEpicBoard(currentBoardId: string) {
  const _this = getCurrentInstance();
  const proxy: any = _this?.proxy?.$store;

  const openQuickCard = () => {
    const epicId = currentBoardId.split('-')[1];
    if (!epicId) return;

    const epic = proxy.getters.getCardById(epicId);
    proxy.dispatch('setQuickCardField', {
      fieldName: 'epic',
      value: {
        id: epicId,
        icon: epic.icon,
        title: epic.title,
      },
    });
    proxy.dispatch('setCardInEpicCreation', epic.id);
    proxy.dispatch('setQuickCard', true);
  };

  const openFindCard = () => {
    const epicId = currentBoardId.split('-')[1];
    if (!epicId) return;

    proxy.dispatch('setCurrentCardIdForActionEdit', epicId);
    proxy.dispatch('setShowSetParentCardPopup', `addCardToEpic-${constants.boardView}`);
  };
  return { openQuickCard, openFindCard };
}
